import React from "react";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faTwitter,
  faCodepen,
  faDribbble,
  faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

import { faEnvelope, faGlobe } from "@fortawesome/free-solid-svg-icons";
// import { faTwitter } from "@fortawesome/free-solid-svg-icons";

function Mainpage() {
  function emailClick() {
    window.open("mailto:jon-e-worldwide@jon-e.org", "_blank");
  }
  function linkedinClick() {
    window.open("https://www.linkedin.com/in/jonathanelias1/", "_blank");
  }

  function githubClick() {
    window.open("https://github.com/JonathanElias1", "_blank");
  }

  function codepenClick() {
    window.open("https://codepen.io/jonathanelias1", "_blank");
  }

  function twitterClick() {
    window.open("https://twitter.com/joncodeguy", "_blank");
  }

  //   function dribbbleClick() {
  //     window.open("https://dribbble.com", "_blank");
  //   }

  function siteClick() {
    window.open("https://jon-e.com", "_blank");
  }

  //make this turn cursor into a pointer when hovering over something eventually
  function mouseOver() {
    console.log(`test`);
  }

  return (
    // Logo
    <div className="pages">
      <div className="logo">
        <img
          src="/assets/images/devjon blue and orange.png"
          id="myLogo"
          alt="devJon logo"
          className="dev-jon"
        />
      </div>
      {/* Introduction */}

      <section className="intro" id="home">
        <h1 className="section__title section__title--intro">
          Hi, I am <strong> Jon Elias </strong>
        </h1>
        <p className="section__subtitle section__subtitle--intro">
          FRONT-END DEV
        </p>
        <img
          src="/assets/images/devjon.jpg"
          alt="a picture of Jon smiling"
          className="intro__img"
        />
      </section>

      {/* what I do aka services */}
      <section className="my-services" id="services">
        <h2 className="section__title section__title--services">What I do</h2>
        <div className="services">
          <div className="service">
            {/* service 1 */}
            <h3>Marketing/Videography</h3>
            <p>
              I am proficient in marketing, user experience, and videography.
            </p>
          </div>

          {/*service 2*/}
          <div className="service">
            <h3>REACT</h3>
            <p>
              I have built over 20 plus applications in React and am very
              comfortable with learning libraries and frameworks within it.
            </p>
          </div>
          {/*service 3*/}

          <div className="service">
            <h3>Design</h3>
            <p>
              I pride myself in my ability to design websites with my CSS
              expertise.
            </p>
          </div>
        </div>

        {/* //make this button below link to my projects */}
        <a href="#work" className="btn">
          My Work
        </a>
      </section>

      {/* Who I am  aka about */}

      <section className="about-me" id="about">
        <h2 className="section__title section__title--about">Who I am</h2>
        <p className="section__subtitle section__subtitle--about">
          Developer & Designer based out of AZ
        </p>

        <div className="about-me__body">
          <p>
            Entry level front end developer with proven problem solving, time
            management, research and analytical skills. The ultimate
            role-filler, capable of being an amazing teammate while also having
            proven the ability to lead teams effectively. Passionate about
            learning and development with a desire to apply skills on a
            development team. Eager to tackle more complex problems and continue
            to find ways to maximize user efficiency.
          </p>
          {/* <p></p> */}
        </div>
        <img
          src="/assets/images/JON-E2.jpg"
          alt="Jon leaning"
          className="about-me__img"
        />
      </section>

      {/* Portfolio aka my work */}
      <section className="my-work" id="work">
        <h2 className="section__title section__title--work">My work</h2>
        <p className="section__subtitle section__subtitle--work">
          A selection of my range of work
        </p>

        <div className="portfolio">
          {/* Portfolio item 01 */}
          <Link className="portfolio__item" to="/portfolio1">
            <img
              // src="/assets/images/portfolio-01.jpg"
              src="/assets/images/WPM GAME 2.png"
              alt=""
              className="portfolio__img"
            />
          </Link>
          {/* Portfolio item 02 */}
          <Link className="portfolio__item" to="/portfolio2">
            <img
              // src="/assets/images/portfolio-01.jpg"
              src="/assets/images/CSSGUIDESITE.png"
              alt=""
              className="portfolio__img"
            />
          </Link>
          {/* Portfolio item 03 */}
          {/* <a href="portfolio-item.html" className="portfolio__item">
            <img
              src="/assets/images/portfolio-03.jpg"
              alt=""
              className="portfolio__img"
            />
          </a> */}
          {/* Portfolio item 04
          <a href="portfolio-item.html" className="portfolio__item">
            <img
              src="/assets/images/portfolio-04.jpg"
              alt=""
              className="portfolio__img"
            />
          </a>
          Portfolio item 05
          <a href="portfolio-item.html" className="portfolio__item">
            <img
              src="/assets/images/portfolio-05.jpg"
              alt=""
              className="portfolio__img"
            />
          </a>
          Portfolio item 06
          <a href="portfolio-item.html" className="portfolio__item">
            <img
              src="/assets/images/portfolio-06.jpg"
              alt=""
              className="portfolio__img"
            />
          </a>
          Portfolio item 07
          <a href="portfolio-item.html" className="portfolio__item">
            <img
              src="/assets/images/portfolio-07.jpg"
              alt=""
              className="portfolio__img"
            />
          </a>
          Portfolio item 08
          <a href="portfolio-item.html" className="portfolio__item">
            <img
              src="/assets/images/portfolio-08.jpg"
              alt=""
              className="portfolio__img"
            />
          </a>
          Portfolio item 09
          <a href="portfolio-item.html" className="portfolio__item">
            <img
              src="/assets/images/portfolio-09.jpg"
              alt=""
              className="portfolio__img"
            />
          </a>
          Portfolio item 10
          <a href="portfolio-item.html" className="portfolio__item">
            <img
              src="/assets/images/portfolio-10.jpg"
              alt=""
              className="portfolio__img"
            />
          </a> */}
        </div>
      </section>

      {/* Footer */}
      <div className="footer" id="footer">
        <div>
          <a
            className="footer__link"
            onClick={emailClick}
            onMouseOver={mouseOver}
          >
            jon-e-worldwide@jon-e.org
            {/* <FontAwesomeIcon icon={faEnvelope}></FontAwesomeIcon>{" "} */}
          </a>
        </div>

        <ul className="social-list">
          <li className="social-list__item">
            <a className="social-list__link" onClick={githubClick}>
              <FontAwesomeIcon icon={faGithub}></FontAwesomeIcon>
            </a>
          </li>

          <li className="social-list__item">
            <a className="social-list__link" onClick={twitterClick}>
              <FontAwesomeIcon icon={faTwitter}></FontAwesomeIcon>
            </a>
          </li>

          <li className="social-list__item">
            <a className="social-list__link" onClick={codepenClick}>
              <FontAwesomeIcon icon={faCodepen}></FontAwesomeIcon>{" "}
            </a>
          </li>

          {/* <li className="social-list__item">
            <a className="social-list__link" onClick={dribbbleClick}>
              <FontAwesomeIcon icon={faDribbble}></FontAwesomeIcon>{" "}
            </a>
          </li> */}

          <li className="social-list__item">
            <a className="social-list__link" onClick={siteClick}>
              <FontAwesomeIcon icon={faGlobe}></FontAwesomeIcon>{" "}
            </a>
          </li>

          <li className="social-list__item">
            <a className="social-list__link" onClick={linkedinClick}>
              <FontAwesomeIcon icon={faLinkedin}></FontAwesomeIcon>{" "}
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Mainpage;
